import React, { useState } from 'react'
import { Modal, Upload, Button, message } from 'antd'
import type { UploadProps } from 'antd'
import { InboxOutlined } from '@ant-design/icons'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

const EXCEL_ACCEPT = '.xlsx,.xls,.xlsb,.xlsm'

interface UploadFileModalProps<TExtra = any> {
  open: boolean
  onClose: () => void
  accept?: string
  extraPayload?: TExtra
  actionCreator: (file: File, extra?: TExtra) => any
}

export const UploadFileModal = <TExtra,>({
  open,
  onClose,
  accept = EXCEL_ACCEPT,
  actionCreator,
  extraPayload,
}: UploadFileModalProps<TExtra>) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [file, setFile] = useState<File | null>(null)

  const props: UploadProps = {
    accept,
    maxCount: 1,
    beforeUpload: file => {
      setFile(file)
      return false
    },
    onRemove: () => {
      setFile(null)
    },
  }

  const handleClose = () => {
    setFile(null)
    onClose()
  }

  const handleSubmit = () => {
    if (!file) {
      message.error(t('please_select_file') || 'Vui lòng chọn file')
      return
    }

    dispatch(actionCreator(file, extraPayload))
    message.success(`Đã gửi file: ${file.name}`)
    handleClose()
  }

  return (
    <Modal
      title={<p style={{ fontWeight: 700, margin: 0 }}>{t('upload')}</p>}
      open={open}
      onCancel={handleClose}
      footer={null}
      destroyOnClose
    >
      <Upload.Dragger {...props} fileList={file ? [file as any] : []}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">{t('uploadInstruction')}</p>
        <p className="ant-upload-hint">{t('uploadAccept', { accept })}</p>
      </Upload.Dragger>

      <div style={{ marginTop: 16, textAlign: 'right' }}>
        <Button onClick={handleClose} style={{ marginRight: 8 }}>
          {t('cancel')}
        </Button>
        <Button type="primary" onClick={handleSubmit} disabled={!file}>
          {t('ok')}
        </Button>
      </div>
    </Modal>
  )
}
